import React, { useEffect, useState } from "react";
import { useOemHealth } from '../../context/OEMHealth';
import { OemServiceIssue } from "../../types";
import { useHistory, useLocation } from "react-router-dom";

const OemHealthBanner = ({ isAuthenticated }) => {
  const history = useHistory();
  const location = useLocation();

  const { isOemHealthLoading, oemServiceIssues } = useOemHealth();

  const [serviceIssues, setServiceIssues] = useState<OemServiceIssue[]>([]);
  const [status, setStatus] = useState<'degraded' | 'down'>();

  const handleClick = () => {
    history.push("/miscFunctions/oemHealth");
  };

  useEffect(() => {
    setServiceIssues(oemServiceIssues);
  }, [oemServiceIssues]);

  useEffect(() => {
    if (serviceIssues.length) {
      setStatus(serviceIssues.some(issue => issue.serviceLevel.toLowerCase() === "down") ? "down" : "degraded");
    }
  }, [serviceIssues])

  return (
    !isAuthenticated || location.pathname.includes("userProfile") || location.pathname.includes("oemHealth") || isOemHealthLoading || (serviceIssues ?? []).length === 0 
      ? <></>
      : <div className={`c-box c-box--oem-health-banner-${status} u-margin-top-xlarge u-margin-bottom-none`}>
          <div className="u-width-100-percent l-flex-between u-gap-2rem u-align-center">
            <div className="c-notice__content">
              <div className="c-notice__title h2 u-no-wrap">
                OEM Health
              </div>
              <div className="c-notice__text">
                {serviceIssues.length === 1 
                  ? <>
                      Status for {serviceIssues[0]?.oemName}: {' '} 
                      <span className={`oem-health-banner-service-level`}>
                        {serviceIssues[0]?.serviceLevel?.toUpperCase()}
                      </span>
                    </>
                  : <>
                      Services Are Experiencing Issues: {' '}
                      {serviceIssues.map((issue, i) => 
                        <span key={issue?.oemID}>
                          {issue?.oemName}{' '}
                            <span className={`oem-health-banner-service-level`}>
                              ({issue?.serviceLevel?.toUpperCase()})
                            </span>
                          {i !== (serviceIssues.length - 1) 
                            ? <>,{' '}</>
                            : <></>
                          }
                        </span>
                      )}
                    </>
                }
              </div>
            </div>
            <div className="c-notice__btn">
              <button className="c-btn" onClick={() => handleClick()}>
                <div className="c-btn__inner">
                  View OEM Health
                </div>
              </button>
            </div>
          </div>
        </div>
  )
}

export default OemHealthBanner;